import React, {Component} from 'react'
// import * as firebase from 'firebase';
import firebase from '../helper/firebase'

import {
  Card,
  CardContent,
  CircularProgress,
  TextField,
} from 'material-ui'

import Fade from 'material-ui/transitions/Fade'

import Head from '../components/Head'
import LoggedOutCard from '../components/LoggedOutCard'
import ApplicantCardHeader from '../components/ApplicantCardHeader'
import UnauthorizedText from '../components/UnauthorizedText'
import SectionTitle from '../components/SectionTitle'
import SkillsChips from '../components/SkillsChips'
import {Title} from '../helper/consts'

import {
  GetToken
} from '../helper/functions'

const style = {
  loading:{
    alignSelf: 'center',
    width:'75px',
    height:'75px',
    marginTop:'calc(50vh - 37.5px - 64px)',
  },
  unauthorizedContainer:{
    height: 'calc((((100vh - 64px) - 84px) - 108px) - 36px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
}

export default class User extends Component{
  constructor(props){
    super(props)

    this.state = {
      loggedIn:false,
      authLoading:true,
      loading:true,
      snackStatus:false,
      snackMessage:'',
    }
  }

  componentDidMount(){
    firebase.auth().onAuthStateChanged(user=>{
      if(user){
        this.getInfo();
        this.setState({
          uid:user.uid,
          user:user.providerData[0],
          loggedIn:true,
          authLoading:false,
          loading:true,
        })
      }
      else{
        this.setState({
          loggedIn:false,
          authLoading:false,
          loading:true,

          user:{},
          uid:'',
        })
      }
    })
  }

  getInfo=()=>{
    // console.log('getting');
    const uid = this.props.match.params.uid;
    GetToken().then(token=>{
      let myHeaders = {
        method: 'post',
        headers: {
          'Authorization': 'Bearer ' + token,
        },
      }
      const url = `https://us-central1-talent-7d36f.cloudfunctions.net/getPublicProfile?uid=${uid}`;
      fetch(url,myHeaders)
      .then(res=>{
        // console.log(res);
        return res.json();
      })
      .then(data=>{
        this.setState({
          profile:data.data,
          unauthorized:false,
          loading:false,
        })
      })
      .catch(err=>{
        console.log(err);
        this.setState({
          profile:{},
          unauthorized:true,
          loading:false,
        })
      })
    })
  }

  renderProfile=()=>{
    let html = [];
    html.push(<SectionTitle key='profile_title' title='Profile' />)
    let card = (
      <Fade key='profile' in={true}>
        <Card className="card">
          <ApplicantCardHeader applicant={this.state.profile} />
        </Card>
      </Fade>
    )
    html.push(card)
    return html;
  }

  renderAdditionalDetails=()=>{
    let html = [];
    if(!!this.state.profile.function || !!this.state.profile.industry){
      let title = (
        <SectionTitle key='additional_details_title' title='Additional Details' />
      )
      html.push(title)
    }
    if(!!this.state.profile.function || !!this.state.profile.industry){
      let card = (
        <Fade key='additional_details' in={true}>
          <Card className="card">
            <CardContent>
              {!!this.state.profile.industry?
                <div style={style.profileRow} className="industry">
                  <TextField
                    fullWidth
                    id="industry"
                    label="Industry"
                    value={this.state.profile.industry}
                    margin="normal"
                    disabled={true}
                  />
                </div>
              :
                null
              }
              {!!this.state.profile.function?
                <div style={style.profileRow} className="function">
                <TextField
                  fullWidth
                  id="function"
                  label="Function"
                  value={this.state.profile.function}
                  margin="normal"
                  disabled={true}
                />
                </div>
              :
                null
              }
            </CardContent>
          </Card>
        </Fade>
      )
      html.push(card)
    }
    return html;
  }

  renderSkills=()=>{
    let html = [];
    html.push(<SectionTitle key='profile_skills' title='Skills' />)
    let card = (
      <Card key="skills_card" className="card">
        <CardContent className='skillsChipsContent'>
          <SkillsChips skills={this.state.profile.skills} />
        </CardContent>
      </Card>
    )
    html.push(card)
    return html;
  }

  render(){
    return(
      <React.Fragment>
        <Head title={`User | ${Title}`} />
        <div id={this.state.loggedIn?'loggedInBody':null} className="body">
          {((this.state.loading && this.state.authLoading && !this.state.loggedIn) || (this.state.loading && !this.state.authLoading && this.state.loggedIn)) && <CircularProgress style={style.loading} size={75} />}
          {!this.state.loading && !this.state.authLoading && this.state.loggedIn && this.state.unauthorized &&
            <div style={style.unauthorizedContainer}>
              <UnauthorizedText text='Unauthorized' subText='User has restricted public visibility.' />
            </div>
          }
          {!this.state.loading && !this.state.authLoading && this.state.loggedIn && !this.state.unauthorized && this.renderProfile()}
          {!this.state.loading && !this.state.authLoading && this.state.loggedIn && !this.state.unauthorized && this.renderAdditionalDetails()}
          {!this.state.loading && !this.state.authLoading && this.state.loggedIn && !this.state.unauthorized && this.state.profile && this.state.profile.skills && this.renderSkills()}
          {this.state.loading && !this.state.authLoading && !this.state.loggedIn && <LoggedOutCard />}
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/User.js